import { AxiosInstance } from 'axios';
import { axiosFactory } from '../../../../client';
import * as ROUTES from './routes';
import {
  DraftSavedDateTimeResponse,
  SpecialConsiderationReviewResponse,
  SpecialConsiderationSubjectListingResponse,
  SpecialConsiderationSummaryResponse,
  SubjectListingResponse,
  SubjectListingSearchRequest,
  TypesAndReasonsResponse,
} from '../../model';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api/special-considerations`;
const timeout = 10000;

export const specialConsiderationClient = axiosFactory(baseURL, timeout);
export const specialConsiderationCandidateClient = axiosFactory(baseURL, timeout);

export const specialConsiderationTestCandidateClient = (specialConsiderationClient as unknown) as AxiosInstance;

/** to get special consideration subject listing
 * */
export const getSpecialConsiderationSubjectDetails = (requestUuid: string) =>
  specialConsiderationClient.get<SpecialConsiderationSubjectListingResponse[]>(
    `${ROUTES.GET_SPECIAL_CONSIDERATION_SUBJECT_DETAILS(requestUuid)}`
  );

/** to get subject listing
 * */
export const getSubjectDetails = (data: SubjectListingSearchRequest) =>
  specialConsiderationClient.get<SubjectListingResponse>(
    `${ROUTES.GET_SUBJECT_DETAILS(data.requestUuid, data.page, data.pageSize)}`
  );

export const getDraftSavedDateTime = (requestUuid: string) =>
  specialConsiderationClient.get<DraftSavedDateTimeResponse>(
    `${ROUTES.GET_DRAFT_SAVED_DATE_TIME(requestUuid)}`
  );

export const deleteSpecialConsideration = (csrfToken: string, requestUuid: string, uuid: string) =>
  specialConsiderationClient.delete<any>(csrfToken, `${ROUTES.REQUEST_DETAILS(requestUuid, uuid)}`);

export const getTypesAndReasons = () =>
  specialConsiderationClient.get<TypesAndReasonsResponse>(`${ROUTES.GET_TYPES_AND_REASONS}`);

export const getReviewByUuid = (uuid: string) =>
  specialConsiderationClient.get<SpecialConsiderationReviewResponse>(
    `${ROUTES.GET_REVIEW_BY_UUID(uuid)}`
  );

export const getSCAcknowledgement = (uuid: string) =>
  specialConsiderationClient.get<any>(`${ROUTES.GET_SC_ACKNOWLEDGEMENT_REQUEST(uuid)}`);

export const getSCSummary = (uuid: string) =>
  specialConsiderationClient.get<SpecialConsiderationSummaryResponse>(
    `${ROUTES.GET_SPECIAL_CONSIDERATION_SUMMARY(uuid)}`
  );
